export default __webpack_public_path__ + "static/media/res2.936aab17.PNG";